module.exports = __webpack_public_path__ + "img/product-center-bg.7eb021d8.png";